/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React,{useEffect, lazy, Suspense} from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import {Layout, LayoutSplashScreen} from "../_metronic/layout";

// Lazily loaded major route branches
const BasePage = lazy(() => import("./basepage"));
const AuthPage = lazy(() => import("./modules/Auth/pages/AuthPage").then(module => ({ default: module.AuthPage })));
const Logout = lazy(() => import("./modules/Auth/pages/Logout"));
const ErrorsPage = lazy(() => import("./modules/ErrorsExamples/ErrorsPage"));

export function Routes() {
    const {isAuthorized} = useSelector(
        ({auth}) => ({
            isAuthorized: auth.user != null,
        }),
        shallowEqual
    );
    useEffect(() => {
        // 
        window.history.pushState(null, document.title, window.location.href);
        window.addEventListener('popstate', function (event){
            window.history.pushState(null, document.title,  window.location.href);
        });
    })

    return (
        <Suspense fallback={<LayoutSplashScreen />}>
            <Switch>
                {!isAuthorized ? (
                    /*Render auth page when user at `/auth` and not authorized.*/
                    <Route>
                        <AuthPage />
                    </Route>
                ) : (
                    /*Otherwise redirect to root page (`/`)*/
                    <Redirect from="/auth" to="/"/>
                )}

                <Route path="/error" component={ErrorsPage}/>
                <Route path="/logout" component={Logout}/>


                {!isAuthorized ? (
                    /*Redirect to `/auth` when user is not authorized*/
                    <Redirect to="/auth/login"/>
                ) : (
                    <Layout>
                        <BasePage/>
                    </Layout>
                )}
            </Switch>
        </Suspense>
    );
}
